module.exports = __webpack_public_path__ + "img/mosaic.eef85fea.png";